const setLastUrl = (lastUrl: object|null) => ({
    type: 'SET_LAST_URL',
    lastUrl
})

export default setLastUrl